import styled from "styled-components"

export interface StyledSkillsProps {
  skillStyle: string
}

export const StyledSkills = styled.div`
`
export const StyledSkillsTitle = styled.p`
  ${(props) => props.theme.mixins.body}
  font-family: ${(props) => props.theme.fonts.circularMedium};
  color: ${(props) => props.theme.colors.darkGrey};
  padding-bottom: 16px;
`
export const StyledSkillsList = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: -4px;
`
export const StyledSkill = styled.div<StyledSkillsProps>`
  padding: 8px 16px;
  border-radius: 64px;
  white-space: nowrap;
  ${(props) => props.theme.mixins.body}
  margin: 4px;
  ${(props => props.skillStyle === "light" ? (`
    background-color: ${props.theme.colors.darkGrey05};
  `) : (`
    background-color: ${props.theme.colors.darkGrey};
    color: ${props.theme.colors.white};
  `))}
  @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
    padding: 6px 12px;
    border-radius: 24px;
  }
`
